import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';

const fetchRebateApi = (sku = '') => {
    try {
        const config = {
            url: `/v2/rebates/${sku}`,
            credentials: 'include',
            apiHost: apiHosts.browse,
            excludeVersion: true,
            contentType: 'application/json',
        };

        return RestClient.get(config).then((response) => {
            return response;
        });
    } catch (error) {
        /* istanbul ignore next */
        console.log(`request failed ${error}`);
    }
};

export default fetchRebateApi;
